export interface RestaurantProductModel {
  id?: string;
  product_id?: string | null;
  definition: ProductDefinitionModel;
}

export interface ProductDefinitionModel {
  type?: RestaurantProductType;
  min_duration: string;
  max_duration: string;
  available_from: string | null;
  available_to: string | null;
  disallowed_before: string | null;
  available_from_date_time?: Date;
  available_to_date_time?: Date;
  restaurant_id?: string | null;
  key?: string | null;
  newsletter?: string | null;
  notes_prefix?: string | null;
  notes_suffix?: string | null;
  price_mismatch_text?: string | null;
  unavailables?: ProductDefinitionPeriod;
  infos?: ProductDefinitionPeriod;
}
export enum RestaurantProductType {
  Unknown = 0,
  RestaurantAndTicket = 1,
  Restaurant = 2,
}

export interface ProductDefinitionPeriod {
  html: string;
  from: string;
  to: string;
  day: string;
  is_full_day: boolean;
}
